<template>
  <div>
    <h2 class="dynamic-page-title">熱門推薦</h2>
    <div class="list-wrap">
      <div v-if="loading" class="data-loading">
        <i class="el-icon-loading" />
      </div>
      <template v-else>
        <div
          v-for="(r, i) in recommendList"
          :key="r.userUuid"
          class="one-recommend"
        >
          <fps-avatar class="recommend-avatar" :src="r.avatarUrl" @click.native="openDetail(r)" />
          <div class="text-info">
            <span class="nickname">{{ r.nickname }}</span>
            <div v-if="r.isOnline" class="online-state">可接單</div>
          </div>
          <button v-if="!userInfo || userInfo.uuid !== r.userUuid" class="reace-btn" :class="r.followStatus === 'Follow' && 'is-reace'" @click="reaceIt(r, i)">
            <i v-show="r.loading" class="el-icon-loading"></i>
            <span v-show="!r.loading && r.followStatus === 'Unfollow'">追蹤</span>
            <span v-show="!r.loading && r.followStatus === 'Follow'">取消追蹤</span>
          </button>
        </div>
        <div v-if="recommendList.length % 2 === 1" class="one-recommend hide-recommend" />
      </template>
    </div>
  </div>
</template>
<script>
import { followUser } from '@/api'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      recommendList: [],
      loading: true,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.getRecommendList()
  },
  methods: {
    openDetail(info) {
      this.$router.push({
        path: `/player-detail/${info.userUuid}`,
      })
    },
    async reaceIt(f, i) {
      if (!this.userInfo) {
        this.$util.Login()
        return
      }
      if (f.loading) return
      f.loading = true
      this.recommendList.splice(i, 1, f)

      const followOptType = f.followStatus === 'Unfollow' ? 'Follow' : 'Unfollow'
      if (followOptType === 'Unfollow') {
        try {
          await this.$confirm({
            content: `確認要取消追蹤 <span class="font-bold">${ f.nickname }</span> 嗎？`,
            confirmButtonText: '取消追蹤',
            cancelButtonText: '再想想',
            closeOnClickModal: false,
            dangerouslyUseHTMLString: true
          })
        } catch (e) {
          f.loading = false
          this.recommendList.splice(i, 1, f)
          return
        }
      }
      followUser({
        followOptType,
        uuid: f.userUuid,
      }).then(() => {
        f.followStatus = followOptType
        f.loading = false
        // if (followOptType === 'Unfollow') {
        //   this.$store.dispatch('app/setSomeUserInfo', {
        //     following: this.userInfo.following - 1
        //   })
        // } else {
        //   this.$store.dispatch('app/setSomeUserInfo', {
        //     following: this.userInfo.following + 1
        //   })
        // }
        this.recommendList.splice(i, 1, f)
        this.$message.success('操作成功')
      }).catch(() => {
        f.loading = false
        this.recommendList.splice(i, 1, f)
        this.$message.error('操作失敗')
      })
    },
    getRecommendList() {
      this.$http.get('/rank/getHotRank')
        .then(({ data }) => {
          if (!data) return
          this.recommendList = data.map(item => {
            item.isOnline = this.$util.isOnline(item)
            return item
          })
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  .list-wrap {
    @include flex(space-between);
    flex-wrap: wrap;
    .data-loading {
      font-size: 24px;
    }
    .one-recommend {
      width: 482px;
      height: 110px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      background: #fff;
      margin-bottom: 16px;
      @include flex;
      padding: 0 20px;
      .recommend-avatar {
        width: 60px;
        height: 60px;
        margin-right: 20px;
        cursor: pointer;
      }
      .text-info {
        flex: 1;
        .nickname {
          font-weight: 500;
          font-size: 16px;
          line-height: 20px;
          letter-spacing: -0.3px;
          color: #333333;
        }
        .online-state {
          @include flex(flex-start);
          margin-top: 4px;
          font-size: 13px;
          line-height: 21px;
          color: $color-gray-3;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #53D842;
            margin-right: 4px;
          }
        }
      }
      .reace-btn {
        width: 80px;
        height: 32px;
        border-radius: 50px;
        border: 1px solid $color-link;
        font-size: 13px;
        line-height: 18px;
        color: $color-link;
        &:hover {
          background: rgba(0, 122, 255, 0.1);
          border: 1px solid #007AFF;
          color: $color-link;
        }
        &.is-reace {
          border: 1px solid $color-split;
          color: $color-gray-2;
          &:hover {
            background: rgba(232, 234, 238, 0.3);
            border: 1px solid $color-split;
            color: $color-gray-2;
          }
        }
      }
    }
    .hide-recommend {
      visibility: hidden;
    }
  }
</style>
